import type { SVGProps } from 'react';
const SvgStorage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#storage_svg__a)">
      <path
        fill="currentColor"
        d="M2 20h20v-4H2v4Zm2-3h2v2H4v-2ZM2 4v4h20V4H2Zm4 3H4V5h2v2Zm-4 7h20v-4H2v4Zm2-3h2v2H4v-2Z"
      />
    </g>
    <defs>
      <clipPath id="storage_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStorage;
